import { getAuth, signOut } from 'firebase/auth'
import React from 'react'
// import { auth } from '../configs/firebase'
import { replace, useNavigate } from 'react-router-dom'
// import useAuthStore from '../store/store'
import { auth } from '../../configs/firebase'
import { AuthData } from '../../provider/AuthProvider'
import {  EAuthData } from '../../employer/Provider/EAuthProvider'
import { MdLogout } from 'react-icons/md'
import { useAppType } from '../../provider/AppTypeProvider'

const LogoutButton = ({style, AuthData}) => {
    const navigate = useNavigate()
    const { appType } = useAppType();
    const {logout} = AuthData()

    const handleLogout = async()=>{
        try{
            console.log("Logging out...");
            await logout()
            navigate("/main-signup", {replace:true})
        }catch(error){
            console.log(error)
        }

    }
    
  return (
    <button onClick={handleLogout}
            className={`flex justify-between items-center bg-none rounded-b px-4 py-2 border-slate-500 text-left hover:bg-red-300 ${style ? style: ''}`}
        >
            <p>Logout</p>
            <MdLogout className='h-6 w-6' />
    </button>
  )
}

export default LogoutButton